import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  outline: none;\n  display: inline-flex;\n  box-sizing: content-box;\n  justify-content: center;\n  flex-direction: column;\n  flex-shrink: 0;\n  padding: 0;\n  padding-right: ", ";\n  border-radius: 4px;\n  ", "\n  ", "\n  ", ";\n  svg {\n    transition: transform 0.3s ease-in-out, fill 0.15s ease-out;\n  }\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import SvgIcon from '../../SvgIcon';
import { getPx } from '../../helpers/common';
import { INPUT_HEIGHT, INPUT_HORIZONTAL_PADDING } from '../../Input/constants';
import { ICON_SIZE } from '../../constants';
import { BACKGROUND_GRAY, INACTIVE_GRAY } from '../../colors';
import { height } from '../../style/height';
import { minWidth } from '../../style/min-width';
var FormIconRightWrapper = styled(SvgIcon)(_templateObject(), getPx(INPUT_HORIZONTAL_PADDING), height(INPUT_HEIGHT), minWidth(ICON_SIZE), function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? "\n        background-color: " + BACKGROUND_GRAY + ";\n        color: " + INACTIVE_GRAY + ";\n        cursor: default;\n        pointer-events: all;\n      " : '';
}, function (_ref2) {
  var $open = _ref2.$open;
  return $open ? "\n        svg {\n          transform: rotate(180deg);\n        }\n      " : '';
}, function (_ref3) {
  var $multiline = _ref3.$multiline;
  return $multiline ? "\n        position: absolute;\n        bottom: 0;\n        right: 0;\n      " : '';
});
export default FormIconRightWrapper;